"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var useMediaQuery_1 = __importDefault(require("stremio/common/useMediaQuery"));
var MetaPreview_1 = __importDefault(require("stremio/components/MetaPreview"));
var MetaPreviewSheet_1 = __importDefault(require("stremio/components/MetaPreviewSheet"));
var ActionButton_1 = __importDefault(require("stremio/components/MetaPreview/ActionButton"));
var MetaLinks_1 = __importDefault(require("stremio/components/MetaPreview/MetaLinks"));
var ModalDialog_1 = __importDefault(require("stremio/components/ModalDialog"));
var screen_sizes_less_1 = __importDefault(require("stremio/common/screen-sizes.less"));
var ProgramInfo_1 = __importDefault(require("./ProgramInfo"));
var EpgProgramModal_less_1 = __importDefault(require("./EpgProgramModal.less"));
var EpgProgramModal = function (_a) {
    var _b, _c, _d;
    var program = _a.program, now = _a.now, show = _a.show, onCloseRequest = _a.onCloseRequest, channelHref = _a.channelHref;
    var t = (0, react_i18next_1.useTranslation)().t;
    var isMobile = (0, useMediaQuery_1.default)("(max-width: ".concat(screen_sizes_less_1.default.xsmall, ")"));
    var genres = ((_b = program.genres) === null || _b === void 0 ? void 0 : _b.length) ?
        program.genres
        :
            (_d = (_c = program.links) === null || _c === void 0 ? void 0 : _c.filter(function (_a) {
                var category = _a.category;
                return category === 'Genres';
            }).map(function (_a) {
                var name = _a.name;
                return name;
            })) !== null && _d !== void 0 ? _d : [];
    var preview = (react_1.default.createElement(MetaPreview_1.default, { className: EpgProgramModal_less_1.default['preview'], compact: true, name: program.title, background: program.thumbnail, description: program.overview, metadata: react_1.default.createElement(ProgramInfo_1.default, { program: program, now: now }), actions: channelHref ?
            react_1.default.createElement(ActionButton_1.default, { className: EpgProgramModal_less_1.default['channel-button'], icon: 'chevron-forward', label: t('LIVE_TV_VIEW_CHANNEL', { defaultValue: 'View channel' }), variant: 'wide', href: channelHref, onClick: onCloseRequest })
            :
                null }, genres.length > 0 ?
        react_1.default.createElement(MetaLinks_1.default, { className: EpgProgramModal_less_1.default['genres'], label: 'Genres', links: genres.map(function (genre) { return ({ label: genre }); }) })
        :
            null));
    if (isMobile) {
        return (react_1.default.createElement(MetaPreviewSheet_1.default, { show: show, onCloseRequest: onCloseRequest, ariaLabel: program.title }, preview));
    }
    return show ? (react_1.default.createElement(ModalDialog_1.default, { className: EpgProgramModal_less_1.default['modal'], onCloseRequest: onCloseRequest, role: 'dialog', "aria-modal": 'true', "aria-label": program.title }, preview)) : null;
};
exports.default = EpgProgramModal;
